import React, { useState } from "react";
import "../css/mobileapp.css";
import { FaAndroid, FaApple, FaCheckCircle } from "react-icons/fa";
import logo1 from "../assets/logo.png";

export default function AppDownload() {
  const [downloading, setDownloading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleDownload = () => {
    setDownloading(true);
    setSuccess(false);

    setTimeout(() => {
      window.location.href = "/tvk v2.0.apk"; // place apk in public folder
      setDownloading(false);
      setSuccess(true);
    }, 1500);
  };

  return (
    <div className="mobile-container">

      {/* HEADER */}
      <div className="mobile-header">
        <img src={logo1} alt="TVK Logo" className="mobile-logo" />
      </div>

      <div className="contact-page">

        <h2 className="contact-title">TVK மொபைல் ஆப்</h2>
        <p className="app-subtitle">TVK Thirparappu App Download</p>

        {/* APP CARD */}
        <div className="app-download-box">

          <div className="app-icon">
            <img src={logo1} alt="app icon" />
          </div>

          <h3 className="app-name">TVK Official App</h3>

          <p className="app-desc">
            தமிழ்நாடு மக்களுக்கு விரைவான தகவல்கள், வீடியோக்கள் மற்றும் 
            புதுப்பிப்புகளை பெற TVK Premium App ஐ பதிவிறக்குங்கள்.
          </p>

          {/* ANDROID BUTTON */}
          <button className="download-btn android" onClick={handleDownload}>
            <FaAndroid size={20} />
            Android APK Download
          </button>

          {/* IOS BUTTON */}
          <button className="download-btn ios">
            <FaApple size={20} />
            iOS Coming Soon
          </button>

        </div>

        {/* Downloading */}
        {downloading && (
          <div className="uploading">
            <div className="spinner"></div>
            <p>ஆப் பதிவிறக்கம் தொடங்குகிறது...</p>
          </div>
        )}

        {/* Success */}
        {success && (
          <div className="upload-success">
            <FaCheckCircle color="green" size={24} />
            <p>✅ Download Started</p>
          </div>
        )}

      </div>
    </div>
  );
}